const base = '/search'

const routes = {
  root: base,
  searchLibrary: `${base}/library`,
  searchRequirements: `${base}/requirements`,
}

export default routes
